/* eslint-disable react/prop-types */
import { SearchOutlined, CaretDownFilled } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Form, Input, notification, Popconfirm, Row, Select, Space, Upload } from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { UploadProgressResponse } from '../../medical/medicalSlice'
import {
  selectInsuranceArray,
} from '../../tenant/setting/TenentSettingSlice'
import { getUploadProgress, uploadExcelAsync } from '../InsuranceSlice'
const { Option } = Select

export interface CurrentQueryProps {
  onValueChange: (vs: any) => void
  showNameSearch?: boolean
  code: number //  1318医保限价 1312省目录 1319 支付比例
}
export const CurrentQuery: React.FC<CurrentQueryProps> = ({
  onValueChange,
  code,
  showNameSearch = true,
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const Uploadref = useRef<any>(null)

  const insuranceArray = useSelector(selectInsuranceArray)

  const [isIncremental, setIsIncremental] = useState(0) // 全量0 增量1

  const [showProgress, setShowProgress] = useState(false)

  const [message, setMessage] = useState('')

  const [progress, setProgress] = useState('')

  const [idsList, setIdsList] = useState(0)

  const upload = (file: any, onSuccess: any) => {
    if (file instanceof File) {
      const params = {
        code,
        insuranceCode: form.getFieldValue('insuranceCode'),
        isIncremental: isIncremental,
        file,
        listType: '000'
      }
      dispatch(uploadExcelAsync(params)).then(unwrapResult).then((result: any) => {
        notification.success({
          message: '导入成功',
          duration: 3,
        })
        console.log(result);
        setIdsList(result.id)
        setShowProgress(result?.taskStatus === 0 || result?.taskStatus === 9)
        // form.submit()
      })
      onSuccess &&
        onSuccess(null, (null as unknown) as XMLHttpRequest)
    }
  }

  let timer: any = null
  useEffect(() => {
    if (timer && !showProgress) {
      clearInterval(timer)
    }
    if (idsList) {
      if (!timer && showProgress) {
        timer = setInterval(() => {
          getProgress()
          if (!showProgress) {
            clearInterval(timer)
          }
        }, 3000)
      }
    }
    return () => {
      timer && clearInterval(timer)
    }
  }, [showProgress])

  const getProgress = () => {
    dispatch(getUploadProgress({ ids: [idsList] })).then(unwrapResult).then((res: Array<UploadProgressResponse>) => {
      if (res.length) {
        setShowProgress(res[0]?.taskStatus === 0)
        setMessage(res[0]?.taskMsg)
        if (res[0].taskCnt !== 0 || res[0].taskSum !== 0) {
          const str = `${res[0].taskCnt} / ${res[0].taskSum} `
          setProgress(str)
        }
        if (res[0]?.taskStatus === 1) {
          notification.success({
            message: res[0]?.taskMsg
          })
        }
      } else {
        setShowProgress(false)
      }
    })
  }

  useEffect(() => {
    if (insuranceArray.length) {
      form.setFieldsValue({
        insuranceCode: insuranceArray[0].insuranceCode,
      })
    }
  }, [insuranceArray])

  useEffect(() => {
    setIsIncremental(0)
  }, [code])

  return (
    <Form
      form={form}
      autoComplete='off'
      onFinish={(vs) => {
        onValueChange(vs)
      }}
    >
      <Row
        justify='space-between'
        align='middle'
        style={{ marginTop: 10, marginBottom: 20, width: '100%' }}
        wrap={false}
      >
        <Space>
          {/* {showNameSearch && ( */}
          <Form.Item name='name' noStyle>
            <Input
              allowClear
              placeholder={`请输入${showNameSearch ? '目录名称' : '中心编码'}`}
              prefix={<SearchOutlined />}
              style={{ width: '200px' }}
              onChange={form.submit}
            />
          </Form.Item>
          {/* )} */}

          <Form.Item name='insuranceCode' noStyle>
            <Select
              suffixIcon={<CaretDownFilled />}
              placeholder='医保险种'
              onChange={form.submit}
              style={{ width: '130px' }}
            >
              {insuranceArray.length !== 0 &&
                insuranceArray.map((v: any) => (
                  <Option key={v.insuranceCode} value={v.insuranceCode}>
                    {v.insuranceName}
                  </Option>
                ))}
            </Select>
          </Form.Item>
          <Button type='primary' onClick={form.submit}>
            查询
          </Button>
        </Space>
        <Space style={{ marginRight: '50px' }}>
          <Upload
            style={{ display: 'none' }}
            ref={Uploadref}
            accept='.xls,.xlsx'
            maxCount={1}
            customRequest={({ file, onSuccess }) => {
              console.log('file', file);
              upload(file, onSuccess)
            }}
            showUploadList={false}
          >
          </Upload>
          {/* <Button type='primary'>下载医疗目录</Button> */}
          {
            showProgress && (
              <>
                {message}{progress ? ':' + progress : ''}
              </>
            )
          }
          <Popconfirm
            title="是否全量导入？"
            onConfirm={() => {
              setIsIncremental(0)
              Uploadref?.current.upload.uploader.onClick()
            }}
            onCancel={() => {
              setIsIncremental(1)
              Uploadref?.current.upload.uploader.onClick()

            }}
            okText="全量上传"
            cancelText="增量上传"
          >
            <a href="#">
              <Button type='primary'>
                Excel上传目录
              </Button>
            </a>
          </Popconfirm>
          {/* {
            code !== 1318 && (
              <Button type='primary' onClick={() => {
                const data = {
                  insuranceCode: form.getFieldValue('insuranceCode'),
                  listType: getListType(code)
                }
                dispatch(syncInsuranceListAsync(data)).then(unwrapResult).then((res) => {
                  console.log(132165, res);

                })
              }}>目录同步</Button>
            )
          } */}
        </Space>
      </Row>
    </Form>
  )
}
